import React, { useEffect, useState } from "react";
import axios from "axios";
import MainLogo from "../../../src/assets/image/main-logo.png";
import { useLocation } from "react-router-dom";
import Footer from "../superAdmin/footer/Footer";
import { useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import Select from "react-select";
import { Spinner } from "react-bootstrap";
import TokenUndefined from "../Service/TokenUndefined";
import { message } from "antd";
import FormatChecker from "../Service/FormatChecker";
import CommonFileUploader from "../../common/CommonFileUploader";
import moment from "moment";
import { validateImage } from "../../utils/ImageValidation";

function VisitorForm({
  formHeader,
  formName,
  editStatus,
  companyType,
  edit_name,
  edit_contact,
  edit_phone,
  edit_email,
  id,
  barcode,
  barcodeId,
}) {
  let editName = edit_name === undefined ? "" : edit_name;
  let editContact = edit_contact === undefined ? "" : edit_contact;
  let editPhone = edit_phone === undefined ? "" : edit_phone;
  let editEmail = edit_email === undefined ? "" : edit_email;

  const navigate = useNavigate();

  let currentLocation = useLocation().pathname;

  const designationArray = ["Owner", "Representative "];
  const visitingAsArray = [
    "Wholesaler",
    "Manufacturer",
    "Retailer",
    "Chain Store   ",
    "Agent/Broker",
  ];

  const [visitorFirstName, setVisitorFirstName] = useState("");
  const [visitorLastName, setVisitorLastName] = useState("");

  const [number, setNumber] = useState(editPhone);
  const [visitorName, setVisitorName] = useState(editContact);
  const [designation, setDesignation] = useState("");
  const [visitingCategory, setVisitingCategory] = useState("");
  const [visitingID, setVisitingID] = useState("");
  const [visiting_as, setVisiting_as] = useState("");
  const [yourCompany, setYourCompany] = useState();
  const [comapnyList, setComapnyList] = useState([]);
  const [invitedByCompany, setInvitedByCompany] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState(editEmail);
  const [postalCode, setPostalCode] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [streetAddress, setStreetAddress] = useState("");
  const [streetAddressTwo, setstreetAddressTwo] = useState("");
  const [country, setCountry] = useState("");
  const [hearAbout, setHearAbout] = useState("");
  const [photo, setPhoto] = useState();
  const [idProofFront, setIDProofFront] = useState();
  const [idProofBack, setIDProofBack] = useState();
  const [invitedCompanyName, setInvitedCompanyName] = useState(editName);
  const [visitingDay, setVisitingDay] = useState("");
  const [reload, setReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPhotoLoading, setIsPhotoLoading] = useState(false);
  const [exhibitorName, setExhibitorName] = useState("");
  const [photoStatus, setPhotoStatus] = useState(false);
  const [idFrontStatus, setIdFrontStatus] = useState(false);
  const [idBackStatus, setIdBackStatus] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [gst_number, setGst_number] = useState("");
  const [showError, setShowError] = useState("");
  const [reloadShow, setReloadShow] = useState(false);
  const [duplicateError, setDuplicateError] = useState(false);
  const [ownerStatus, setOwnerStatus] = useState(true);
  const [vipStatus, setVipStatus] = useState(null);
  const [mobileExistsMsg, setMobileExistsMsg] = useState("");
  const [errorNumber, setErrorNumber] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [isGSTPrefilled, setIsGSTPrefilled] = useState(false);


  const handleMobileNoChange = (e) => {
    const input = e.target.value;
    const numericValue = input.replace(/\D/g, "");
    setNumber(numericValue);
    if (numericValue.length < 10) {
      setMobileExistsMsg("");
      setErrorNumber("")
      return;
    }

    if (
      numericValue.length === 10 &&
      (formName === "exhibitor_vip" ||
        formName === "exhibitor_owner" ||
        formName === "exhibitor_staff")
    ) {
      axios
        .get(
          `${process.env.REACT_APP_API_END_POINT}/check-is-number/${numericValue}/${formName}`
        )
        .then((resData) => {
          setMobileExistsMsg(resData.data.message);
          setErrorNumber(resData.data.message);
        });
    }
  };

  let formJson = {
    visitor: [
      "mobile",
      "visitor_name",
      "designation",
      "visiting_as",
      // "invited_company",
      "email",
      "street_add_line1",
      "street_add_line2",
      "city",
      "state",
      "zipcode",
      "country",
      "hduhear",
      "photo",
      "id_front",
      "id_back",
      // "visiting_day",
    ],
    exhibitor_owner: [
      "mobile",
      "visitor_first_name",
      "visitor_last_name",
      // "designation",
      // "visiting_as",
      // "invited_company",
      // "email",
      // "street_add_line1",
      // "street_add_line2",
      // "city",
      // "state",
      // "zipcode",
      // "country",
      // "hduhear",
      "photo",
      // "id_front",
      // "id_back",
      // "visiting_day",
      "UTR",
      "isExtra",
    ],
    exhibitor_staff: [
      "mobile",
      "visitor_first_name",
      "visitor_last_name",
      // "designation",
      // "visiting_as",
      // "invited_company",
      // "email",
      // "street_add_line1",
      // "street_add_line2",
      // "city",
      // "state",
      // "zipcode",
      // "country",
      // "hduhear",
      "photo",
      // "id_front",
      // "id_back",
      // "visiting_day",
    ],
    exhibitor_modal: ["mobile", "visitor_name", "photo", "id_front", "id_back"],
    exhibitor_family: [
      "mobile",
      "visitor_name",
      "photo",
      "id_front",
      "id_back",
    ],
    exhibitor_vip: [
      "mobile",
      "visitor_first_name",
      "visitor_last_name",
      "designation",
      // "visiting_as",
      // "invited_company",
      "email",
      "street_add_line1",
      "street_add_line2",
      "city",
      "gst_number",
      "state",
      "zipcode",
      "country",
      // "hduhear",
      // "photo",
      // "id_front",
      // "id_back",
      // "visiting_day",
      "company_name",
    ],
    vendor_owner: [
      "mobile",
      "visitor_name",
      // "designation",
      // "visiting_as",
      // "invited_company",
      // "email",
      // "street_add_line1",
      // "street_add_line2",
      // "city",
      // "state",
      // "zipcode",
      // "country",
      // "hduhear",
      "photo",
      "id_front",
      "id_back",
      // "visiting_day",
    ],
    edit_update: [
      "visitor_name",
      "mobile",
      "invited_company",
      "email",
      "photo",
      "id_front",
      "id_back",
    ],
    edit_form_update: [
      "visitor_name",
      "mobile",
      "invited_company",
      "email",
      "photo",
      "id_front",
      "id_back",
    ],
    vendor_staff: [
      "mobile",
      "visitor_name",
      // "designation",
      // "visiting_as",
      // "invited_company",
      // "email",
      // "street_add_line1",
      // "street_add_line2",
      // "city",
      // "state",
      // "zipcode",
      // "country",
      // "hduhear",
      "photo",
      "id_front",
      "id_back",
      // "visiting_day",
    ],
  };
  const handlePhoto = async (e) => {
    setIsPhotoLoading(true);

    const file = e.target.files[0];
    e.target.value = "";

    if (!file) {
      setIsPhotoLoading(false);
      return;
    }

    try {
      // First check format
      let dataStatus = FormatChecker(file);
      setPhotoStatus(dataStatus);

      if (dataStatus) {
        message.error("Please upload in the given format");
        setPhoto(null);
        setIsPhotoLoading(false);
        return;
      }

      // Both format and validation passed
      setPhoto(file);

    } catch (error) {
      console.error("Error during photo validation:", error);
      message.error("Failed to process image");
      setPhoto(null);
    } finally {
      setIsPhotoLoading(false);
    }
  }
  const handleFirstName = (e) => {
    setVisitorFirstName(
      e.target.value.replace(/[^A-Za-z]/g, "")
    );
  };

  const handleLastName = (e) => {
    setVisitorLastName(
      e.target.value.replace(/[^A-Za-z]/g, "")
    );
  };

  const handleCity = (e) => {
    const newValue = e.target.value;
    const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
    setCity(alphabetOnlyValue);
  };
  const handleState = (e) => {
    const newValue = e.target.value;
    const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
    setState(alphabetOnlyValue);
  };
  const handleCountry = (e) => {
    const newValue = e.target.value;
    const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
    setCountry(alphabetOnlyValue);
  };

  const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  function checkRegex(input) {
    return regex.test(input);
  }

  function convertToUpperCase(input) {
    return input.replace(/[a-z]/gi, (char) => char.toUpperCase());
  }

  // const handleGstNumberChange = (e) => {
  //   setGst_number(convertToUpperCase(e.target.value));
  //   const value = e.target.value;
  //   if (checkRegex(value)) {
  //     console.log("asdasdasd", e.target.value);
  //     setShowError("");
  //   } else {
  //     setShowError("Provide Valid GSTIN");
  //   }
  // };
  const handleGstNumberChange = (e) => {

    let value = e.target.value.toUpperCase();

    // only allow A–Z and 0–9
    value = value.replace(/[^A-Z0-9]/g, "");

    // max length 15
    if (value.length > 15) return;

    // position-based business validation
    for (let i = 0; i < value.length; i++) {
      const ch = value[i];
      const pos = i + 1;

      if (pos <= 2 && !/[0-9]/.test(ch)) return;
      if (pos > 2 && pos <= 7 && !/[A-Z]/.test(ch)) return;
      if (pos > 7 && pos <= 11 && !/[0-9]/.test(ch)) return;
      if (pos === 12 && !/[A-Z]/.test(ch)) return;
      if (pos === 13 && !/[1-9A-Z]/.test(ch)) return;
      if (pos === 14 && ch !== "Z") return;
      if (pos === 15 && !/[0-9A-Z]/.test(ch)) return;
    }

    setGst_number(value);

    // if user deletes whole value
    if (value === "") {
      setShowError("Please enter GST");
      return;
    }

    // regex matching behind the scene
    if (checkRegex(value)) {
      setShowError("");
    } else {
      setShowError("Provide Valid GSTIN");
    }
  };

  useEffect(() => {
    if (gst_number.length === 15 && checkRegex(gst_number)) {
      // setReloadShow(true);
      // ;

      axios
        .get(
          `${process.env.REACT_APP_API_END_POINT}/check-gst-validation/${gst_number}`
        )
        .then((resData) => {

          // setReloadShow(false);
          // console.log(
          //   "hello i am here to see the test daeeed",
          //   resData.data.message,
          //   resData.data.data.lgnm,
          //   resData.data.data.pradr.adr
          // );
          // if (resData.data.message === "GSTIN  found.") {
          console.log("gst find or not", resData.data);
          if (resData.data?.flag === false) {
            setShowError(resData.data.message);
            setIsGSTPrefilled(false);   // ❌ unlock fields
            return;
          }
          setShowError("");
          setCompanyName(resData.data.company);
          setStreetAddress(resData.data.address);
          setCity(resData.data.city);
          setState(resData.data.state || "");          // ✅ FIXED
          setPostalCode(resData.data.pincode || "");   // ✅ FIXED
          setCountry("india");   // ✅ FIXED

          setIsGSTPrefilled(true);  // ✅ LOCK FIELDS

        })
        .catch((err) => {
          console.log("gst fetch validation ", err.message);
          setShowError("Facing Problem While Fetching Error");
          setIsGSTPrefilled(false);   // ❌ unlock fields
        });
    } else {
      setIsGSTPrefilled(false); // ❌ GST not valid → editable
    }
  }, [gst_number]);

  const handlePostalCode = (e) => {
    const input = e.target.value;
    const numericValue = input.replace(/\D/g, "");
    setPostalCode(numericValue);
  };
  // useEffect(() => {
  //   axios
  //     .post(
  //       `${process.env.REACT_APP_API_END_POINT}/visitor-category`,
  //       {
  //         id: visitingID,
  //       },
  //       {
  //         headers: {
  //           token: localStorage.getItem("token"),
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log("get-visitor", res.data.data);
  //       setAllCategory(res.data.data);
  //     });
  // }, []);

  function handleIDFront(e) {
    let dataStatus = FormatChecker(e.target.files[0]);
    setIdFrontStatus(dataStatus);
    if (!dataStatus) {
      setIDProofFront(e.target.files[0]);
    } else {
      message.error("please upload in the given format");
    }
  }
  function handleIDBack(e) {
    let dataStatus = FormatChecker(e.target.files[0]);
    setIdBackStatus(dataStatus);
    if (!dataStatus) {
      setIDProofBack(e.target.files[0]);
    } else {
      message.error("please upload in the given format");
    }
  }

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setEmailError("");
  };

  const handleEmailBlur = () => {
    if (!email) {
      setEmailError("");
      return;
    }
    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (!emailPattern.test(email)) {
      setEmailError("Invalid email format");
    } else {
      setEmailError("");
    }
  };

  const handleTransactionId = (e) => {
    const value = e.target.value;
    setTransactionId(e.target.value);
  }

  useEffect(() => {
    emptyField();
  }, [reload]);

  useEffect(() => {
    if (
      formName === "vendor_owner" ||
      formName === "vendor_staff" ||
      companyType === "vendor"
    ) {
      axios
        .get(`${process.env.REACT_APP_API_END_POINT}/get-vendor-list`)
        .then((res) => {
          // console.log("assasdasaadads", res.data.data);
          setComapnyList(res.data.data);
        });
    } else {
      if (formName !== "vendor_staff" && formName !== "vendor_owner") {
        axios
          .get(`${process.env.REACT_APP_API_END_POINT}/get-exhibitor-list`, {
            headers: {
              token: localStorage.getItem("jff_token"),
            },
          })
          .then((res) => {
            // console.log("assasdasaadads", res.data.data);
            setInvitedByCompany(res?.data?.data);
          });
      }
    }
  }, [reload]);

  useEffect(() => {
    const fetchData = async () => {
      const dataNeedTOCheck = await axios.get(
        `${process.env.REACT_APP_API_END_POINT}/form-status-exhibitor`,
        {
          headers: {
            token: localStorage.getItem("jff_token"),
          },
        }
      );

      if (formName === "exhibitor_owner") {
        setOwnerStatus(dataNeedTOCheck.data.ownerstatus);
      } else if (formName === "exhibitor_vip") {
        setVipStatus(dataNeedTOCheck.data.vipstatus);
      }

      const userId = localStorage.getItem("user_id");
      if (formName !== "vendor_staff" && formName !== "vendor_owner") {
        TokenUndefined("exhibitor/login");
      }

      if(formName === "exhibitor_vip" && !dataNeedTOCheck.data.vipstatus ){
        message.error("Buyer Registration limit is already reached"); 
        navigate("/exhibitor/dashboard")
        return;
      }

      if (formName !== "vendor_staff" && formName !== "vendor_owner") {
        axios
          .post(
            `${process.env.REACT_APP_API_END_POINT}/get-exhibitor-name`,
            "",
            {
              headers: {
                token: localStorage.getItem("jff_token"),
              },
            }
          )
          .then((res) => {
            setExhibitorName(res.data.data);
          })
          .catch((err) => {
            if (err.response.status === 401) {
              navigate("/exhibitor/login");
              portalAuth.logoutActive();
            }
          });
      }
    };

    fetchData();
  }, []);

  // const handlePayNow = (res) => {
  //   const barcode = res?.data?.message?.barcode;

  //   if (!barcode) {
  //     console.error("Invalid payment response:", res);
  //     message.error("Unable to initiate payment");
  //     setIsLoading(false);
  //     return;
  //   }

  //   createRazorypayOrder(
  //     process.env.REACT_APP_RAZORPAY_AMOUNT,
  //     barcode,
  //     moment().format("MMM Do YY"),
  //     number,
  //     email
  //   );
  // };

  // const createRazorypayOrder = (
  //   amount,
  //   barcode,
  //   time,
  //   visitorPhoneNumber,
  //   visitorEmailId
  // ) => {
  //   let data = JSON.stringify({
  //     amount: amount,
  //     currency: "INR",
  //     barcode,
  //   });
  //   console.log(barcode);
  //   axios
  //     .post(`${process.env.REACT_APP_API_END_POINT}/payment-request`, data, {
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     })
  //     .then((resData) => {
  //       handleRazorpayScreen(
  //         resData.data.amount,
  //         resData.data.order_id,
  //         barcode,
  //         time,
  //         visitorPhoneNumber,
  //         visitorEmailId
  //       );
  //     })
  //     .catch((error) => {
  //       console.log("error in payment:=>", error.message);
  //     });
  // };

  // const handleRazorpayScreen = async (
  //   amount,
  //   order_id,
  //   barcode,
  //   time,
  //   visitorPhoneNumber,
  //   visitorEmailId
  // ) => {
  //   console.log(barcode);
  //   const res = await loadScript(
  //     "https://checkout.razorpay.com/v1/checkout.js"
  //   );
  //   if (!res) {
  //     message.error("some thing is not good");
  //     return;
  //   }
  //   const options = {
  //     // key: "rzp_live_vGtDUlX79LRuv8"
  //     key: process.env.REACT_APP_RAZORPAY_API_KEY,
  //     amount: amount,
  //     currency: "INR",
  //     name: process.env.REACT_APP_ORGANIZER_NAME,
  //     order_id,
  //     description: `Pay To ${process.env.REACT_APP_ORGANIZER_NAME}`,
  //     image: process.env.REACT_APP_RAZORPAY_LOGO,
  //     notes: { barcode },
  //     handler: function (response) {
  //       console.log("responserazorpay_payment_id", response);
  //       axios
  //         .get(
  //           `${process.env.REACT_APP_API_END_POINT}/payment/${response.razorpay_payment_id}/${barcode}/success`
  //         )
  //         .then((payment_Data) => {
  //           console.log("user data:", barcode, visitorName, time);
  //           console.log(barcode);
  //           // Navigate after successful payment with correct data
  //           navigate("/exhibitor/owner-list");
  //         });
  //     },
  //     modal: {
  //       ondismiss: function (response) {
  //         console.log("responserazorpay_payment_id", response);
  //         axios
  //           .get(
  //             `${process.env.REACT_APP_API_END_POINT}/payment/demo/${barcode}/failed`
  //           )
  //           .then((payment_Data) => {
  //             console.log("payment data", payment_Data.data);
  //           });
  //         // handle failed or canceled payment
  //         navigate("/payment-failed", {
  //           state: {
  //             visitorListData: barcode,
  //             visitorName,
  //             registrationDate: time,
  //           },
  //         });
  //       },
  //     },
  //     prefill: {
  //       name: `${visitorFirstName} ${visitorLastName}`,
  //       email: visitorEmailId,
  //       contact: visitorPhoneNumber,
  //     },
  //     theme: {
  //       color: "#F4C430",
  //     },
  //   };
  //   const paymentObject = new window.Razorpay(options);
  //   paymentObject.open();
  // };

  // const loadScript = (src) => {
  //   return new Promise((resolve) => {
  //     const script = document.createElement("script");
  //     script.src = src;
  //     script.onload = () => {
  //       resolve(true);
  //     };
  //     script.onerror = () => {
  //       resolve(false);
  //     };
  //     document.body.appendChild(script);
  //   });
  // };

  const handleSubmit = async (e) => {
    setIsLoading(true);

    const dataNeedTOCheck = await axios.get(
      `${process.env.REACT_APP_API_END_POINT}/form-status-exhibitor`,
      {
        headers: {
          token: localStorage.getItem("jff_token"),
        },
      }
    );
    if (formName === "exhibitor_owner" && !dataNeedTOCheck.data.ownerstatus) {
      message.error("The limit to add new members has exhausted");
      setIsLoading(false);

      return;
    }
    if (formName === "exhibitor_staff" && !dataNeedTOCheck.data.staffstatus) {
      message.error("The limit to add new members has exhausted");
      setIsLoading(false);

      return;
    }
    if (formName === "exhibitor_vip" && !dataNeedTOCheck.data.vipstatus) {
      message.error("The limit to add new members has exhausted");
      setIsLoading(false);

      return;
    }

    //  formName !== "exhibitor_staff" &&
    // formName !== "exhibitor_vip"
    //  .then((res) => {
    //    console.log(res.data);
    //    if (res.data.staffstatus) {
    //      navigate("/exhibitor/exhibitor-staff-registration");
    //    } else {
    //      message.error("The limit to add new members has exhausted");
    //    }
    //  });

    if (!visitorFirstName) {
      message.error("first Name is required");
      setIsLoading(false);
    } else if (!visitorLastName) {
      message.error("last name is required");
      setIsLoading(false);
    } else if (!number) {
      message.error("Phone Number is required");
      setIsLoading(false);
    } else if (number.length !== 10) {
      message.error("Please Enter 10 Digit Mobile Number");
      setIsLoading(false);
      return;
    } else if (emailError && formName !== "exhibitor_vip") {
      message.error("Invalid email format");
      setIsLoading(false);
      return;
    } else if (!companyName && formName === "exhibitor_vip") {
      message.error("Company Name is required");
      setIsLoading(false);
    } else if (!designation && formName === "exhibitor_vip") {
      message.error("Designation is required");
      setIsLoading(false);
    } else if (!city && formName === "exhibitor_vip") {
      message.error("City is required");
      setIsLoading(false);
    } else if (!country && formName === "exhibitor_vip") {
      message.error("Country is required");
      setIsLoading(false);
    } else if (!gst_number && formName === "exhibitor_vip") {
      message.error("Fill Valid Gst Number");
      setIsLoading(false);
    } else if (!photo && formName !== "exhibitor_vip") {
      message.error("Photo is required");
      setIsLoading(false);
    } else if (
      !idProofFront &&
      formName !== "exhibitor_owner" &&
      formName !== "exhibitor_staff" &&
      formName !== "exhibitor_vip"
    ) {
      message.error("ID Proof Front is required");
      setIsLoading(false);
    } else if (
      !idProofBack &&
      formName !== "exhibitor_owner" &&
      formName !== "exhibitor_staff" &&
      formName !== "exhibitor_vip"
    ) {
      message.error("ID Proof Back is required");
      setIsLoading(false);
    } else {
      if (editStatus) {
        console.log("edit status");
        // if (number.length !== 10) {
        //   message.error("Please Enter 10 Digit Mobile Number");
        //   setIsLoading(false);
        //   return;
        // }
        // if (emailError) {
        //   message.error("Invalid email format");
        //   setIsLoading(false);
        //   return;
        // }
        e.preventDefault();
        const formData = new FormData();

        formData.append("visitor_first_name", visitorFirstName);
        formData.append("visitor_last_name", visitorLastName);
        formData.append("email", email);
        formData.append("company_name", companyName);
        formData.append("mobile_number", number);
        formData.append("invited_exhibitor_id", invitedByCompany);
        formData.append("photo", photo);
        formData.append("id_proof_front", idProofFront);
        formData.append("id_proof_back", idProofBack);
        formData.append("id", id);

        axios
          .post(
            `${process.env.REACT_APP_API_END_POINT}/update-visitor`,
            formData,
            {
              headers: {
                token: `${localStorage.getItem("jff_token")}`,
                barcode,
              },
            }
          )
          .then((res) => {
            if (res.data.messageData) {
              message.error(res.data.messageData);
              setIsLoading(false);
              emptyField();
            } else {
              window.location.reload(true);
              // setReload(!reload)
              // message.success("Form Submit Successfully");
              window.alert("Form Submit Successfully");
              setIsLoading(false);
            }
          })
          .catch((error) => {
            console.error("Axios Error:", error);
          });
      } else {
        // {
        if (!photo && !idProofFront && !idProofBack) {
          axios
            .post(
              `${process.env.REACT_APP_API_END_POINT}/add-visitor`,
              {
                mobile_number: number,
                visitor_first_name: visitorFirstName,
                visitor_last_name: visitorLastName,
                designation: designation,
                visiting_as: visiting_as,
                firm_id: yourCompany,
                invited_exhibitor_id: invitedByCompany,
                email: email,
                company_name: companyName,
                company_address: streetAddress,
                street_address_two: streetAddressTwo,
                city: city,
                gst_number,
                state: state,
                postal_code: postalCode,
                country: country,
                hear_about_jff: hearAbout,
                category: formName,
                visiting_day: visitingDay,
                visitor_category_id: visitingID,
                barcodeId,
                isExtra:false
              },
              {
                headers: {
                  token: localStorage.getItem("jff_token"),
                },
              }
            )
            .then((res) => {
              // setReload(!reload)
              // window.location.reload(true);
              // message.success("Form Submit Successfully");
              if (res.data.messageData) {
                message.error(res.data.messageData);
                setIsLoading(false);
                emptyField();
              } else {
                if (formName === "exhibitor_owner") {
                  message.success('Form Submit Successfully');
                  setIsLoading(false);
                }
                // window.alert("Form Submit Successfully");
                // setIsLoading(false);
                // window.location.reload(true);
                if (formName === "exhibitor_staff") {
                  // console.log("anisdsdif", formName);
                  navigate("/exhibitor/staff-list");
                } else if (formName === "exhibitor_modal") {
                  navigate("/exhibitor/modal-list");
                } else if (formName === "exhibitor_family") {
                  navigate("/exhibitor/family-list");
                } else if (formName === "exhibitor_vip") {
                  // console.log("anisdsdif", formName);
                  message.success('Form Submit Successfully');
                  setIsLoading(false);
                  navigate("/exhibitor/vip-guest-requrest-list");
                }
              }
            })
            .catch((err) => {
              console.error("API Error:", err);

              // 1️⃣ Unauthorized
              if (err?.response && err.response.status === 401) {
                navigate("/superadmin/login");
              portalAuth.logoutActive();
                return;
              }

              // 2️⃣ Server responded with error
              if (err?.response) {
                message.error(err.response.data?.message || "Something went wrong");
              }
              // 3️⃣ No response (network / server down)
              else {
                message.error("Network error. Please try again.");
              }

              setIsLoading(false);
            });
        } else {
          const formData = new FormData();
          formData.append("mobile_number", number);
          formData.append("visitor_first_name", visitorFirstName);
          formData.append("visitor_last_name", visitorLastName);
          formData.append("designation", designation);
          formData.append("visiting_as", visiting_as);
          formData.append("firm_id", yourCompany);
          formData.append("invited_exhibitor_id", invitedByCompany);
          formData.append("email", email);
          formData.append("company_name", companyName);
          formData.append("company_address", streetAddress);
          formData.append("street_address_two", streetAddressTwo);
          formData.append("city", city);
          formData.append("state", state);
          formData.append("postal_code", postalCode);
          formData.append("country", country);
          formData.append("hear_about_jff", hearAbout);
          formData.append("photo", photo);
          formData.append("id_proof_front", idProofFront);
          formData.append("id_proof_back", idProofBack);
          formData.append("category", formName);
          formData.append("visiting_day", visitingDay);
          formData.append("visitor_category_id", visitingID);
          formData.append("barcodeId", barcodeId);
          formData.append(
            "isExtra",
            false
          );
          axios
            .post(
              `${process.env.REACT_APP_API_END_POINT}/add-visitor`,
              formData,
              {
                headers: {
                  token: localStorage.getItem("jff_token"),
                },
              }
            )
            .then((res) => {
              // setReload(!reload)
              // window.location.reload(true);
              // message.success("Form Submit Successfully");
              emptyField();
              if (res.data.messageData) {
                alert(res.data.messageData);
                window.location.reload(true);
                setIsLoading(false);
              } else {
                if (formName === "exhibitor_owner") {
                  message.success('Form Submit Successfully');
                  setIsLoading(false);
                  navigate("/exhibitor/owner-list");
                }
                // console.log("anisdsd", formName);
                if (formName === "exhibitor_staff") {
                  // console.log("anisdsdif", formName);
                  navigate("/exhibitor/staff-list");
                } else if (formName === "exhibitor_modal") {
                  navigate("/exhibitor/modal-list");
                } else if (formName === "exhibitor_family") {
                  navigate("/exhibitor/family-list");
                } else if (formName === "exhibitor_vip") {
                  // console.log("anisdsdif", formName);
                  navigate("/exhibitor/vip-guest-requrest-list");
                }
              }
            })
            .catch((err) => {
              // LoginRedirection("/superadmin/login");

              if (err.response.status === 401) {
                navigate("/superadmin/login");
              portalAuth.logoutActive();
              }
            });
        }
        // }
      }
    }
  };
  const emptyField = () => {
    setGst_number("");
    setVisitorName("");
    setNumber("");
    setEmail("");
    setCompanyName("");
    setDesignation("");
    setYourCompany("");
    setVisiting_as("");
    setStreetAddress("");
    setstreetAddressTwo("");
    setCity("");
    setState("");
    setPostalCode("");
    // setCountrsy("");
    setHearAbout("");
    setPhoto("");
    setIDProofFront("");
    setIDProofBack("");
    setInvitedByCompany("");
    setVisitingCategory("");
    setVisitingID("");
    setInvitedCompanyName("");
    setVisitingDay("");
    setMobileExistsMsg("");
    setErrorNumber("");
    setVisitorFirstName("");
    setVisitorLastName("");
    setTransactionId("");
  };
  const styles = {
    imageDiv: {
      marginTop: "8px",
      width: "100%",
      padding: "10px",
      height: "200px",
      border: "1px solid #ddd",
      borderRadius: "6px",
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#fafafa",
    },

    previewImg: {
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain",
    },

    fileLabel: {
      overflow: "hidden",
      height: "42px",
    },

    clipImg: {
      height: "20px",
      width: "auto",
      marginRight: "8px",
    },
  };

  return (
    <>
      <>
        {/* <img
          src={MainLogo}
          style={{ maxWidth: "150px" }}
          className="m-2"
          alt=""
        /> */}
        {/* <div
          className="text-center py-2 d-flex justify-content-between"
          // style={{ backgroundColor: "rgb(61, 65, 86)" }}
        > */}
        <div className="text-center">
          <h4 className="form-heading">{formHeader}</h4>
        </div>
        {ownerStatus ? (
          <></>
        ) : (
          <div
            className="max-w-md mx-auto mt-4 p-4 rounded border text-center"
            style={{
              borderColor: "#000",
              backgroundColor: "#000",
            }}
          >
            <p className="mt-2 text-white">
              Note: You are performing extra registration, and for extra
              registration we charge ₹1500 + GST per head.
            </p>
          </div>
        )}
        {vipStatus ? (
          <div
            className="max-w-md mx-auto mt-4 p-4 rounded border text-center"
            style={{
              borderColor: "#000", // Red border
              backgroundColor: "#000", // Light red background
            }}
          >
            <p className="mt-2 text-white">
              Note: Buyer's are subjected to approval by BOJ management team.
            </p>
          </div>
        ) : (
          <></>
        )}
        <section style={{ marginBottom: "60px" }}>
          <div className="container">
            <div className="form-body-section">
              <div className="form-body">
                <div className="row">
                  {formJson[formName].includes("mobile") && (
                    // <div className="form-group col-lg-6 col-md-6">
                    //   <label className="fw-bold">
                    //     {formName === "exhibitor_vip" ? (
                    //       <>
                    //         Buyer's Mobile Number <font color="#FF0000">*</font>
                    //       </>
                    //     ) : (
                    //       <>
                    //         Mobile Number <font color="#FF0000">*</font>
                    //       </>
                    //     )}
                    //   </label>
                    //   <input
                    //     className="form-control my-2"
                    //     placeholder="Mobile No."
                    // value={number}
                    // maxLength={10}
                    // onChange={handleMobileNoChange}
                    //   />
                    //   {duplicateError && (
                    //     <p className="text-danger" style={{ fontSize: "10px" }}>
                    //       This buyer is already registered
                    //     </p>
                    //   )}
                    // </div>
                    <div className="form-group col-lg-6 col-md-6">
                      <label className="fw-bold">
                        {formName === "exhibitor_vip" ? (
                          <>
                            Buyer's Mobile Number <font color="#FF0000">*</font>
                          </>
                        ) : (
                          <>
                            Mobile Number <font color="#FF0000">*</font>
                          </>
                        )}
                      </label>
                      <input
                        type="text"
                        className={`form-control my-2 ${mobileExistsMsg.includes("already") ? "border-danger" : mobileExistsMsg ? "border-success" : ""}`}
                        required
                        placeholder="Mobile No."
                        name="staff"
                        value={number}
                        maxLength={10}
                        onChange={handleMobileNoChange}
                        autoComplete="off"
                      />
                      <lable className={mobileExistsMsg ? mobileExistsMsg.includes("already") ? "text-danger" : "text-success" : ""}>
                        {errorNumber}
                      </lable>
                    </div>
                  )}
                  {formJson[formName].includes("gst_number") && (
                    <div className="form-group col-lg-6 col-md-6">
                      {reloadShow && (
                        <Spinner
                          style={{
                            height: "20px",
                            width: "20px",
                            position: "absolute",
                            left: "350px",
                            top: " 278px",
                          }}
                        />
                      )}
                      <label className="fw-bold">
                        Gst Number <font color="#FF0000">*</font>
                      </label>
                      <input
                        className="form-control my-2"
                        value={gst_number}
                        maxLength={15}
                        placeholder="Gst Number"
                        onChange={(e) => {
                          handleGstNumberChange(e);
                        }}
                      />
                      {showError && <p className="text-danger">{showError}</p>}
                    </div>
                  )}

                  {/* First Name */}
                  {formJson[formName].includes("visitor_first_name") && (
                    <div className="form-group col-lg-6 col-md-6">
                      <label className="fw-bold">
                        First Name <font color="#FF0000">*</font>
                      </label>
                      <input
                        className="form-control my-2"
                        placeholder="First Name"
                        value={visitorFirstName}
                        maxLength={50}
                        onChange={handleFirstName}
                      />
                    </div>
                  )}

                  {/* Last Name */}
                  {formJson[formName].includes("visitor_last_name") && (
                    <div className="form-group col-lg-6 col-md-6">
                      <label className="fw-bold">
                        Last Name <font color="#FF0000">*</font>
                      </label>
                      <input
                        className="form-control my-2"
                        placeholder="Last Name"
                        value={visitorLastName}
                        maxLength={50}
                        onChange={handleLastName}
                      />
                    </div>
                  )}



                  {formJson[formName].includes("email") && (
                    <div className="form-group col-lg-6 col-md-6">
                      <label className="fw-bold">Email(Optional)</label>
                      <input
                        className="form-control my-2"
                        placeholder="Email"
                        onChange={(e) => {
                          handleEmailChange(e);
                        }}
                        onBlur={handleEmailBlur}
                      />
                    </div>
                  )}
                  {formJson[formName].includes("company_name") && (
                    <div className="form-group col-lg-6 col-md-6">
                      <label className="fw-bold">
                        Company Name <font color="#FF0000">*</font>
                      </label>
                      <input
                        className="form-control my-2"
                        placeholder="Company Name "
                        value={companyName}
                        disabled={isGSTPrefilled}
                        onChange={(e) => {
                          setCompanyName(e.target.value);
                        }}
                      />
                    </div>
                  )}
                  {/* {formJson[formName].includes("designation") && (
                <div className="form-group col-lg-6 col-md-6">
                  <label>Designation</label>
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="transparent"
                      id="dropdown-basic"
                      className="form-control border my-2"
                    >
                      {designation ? designation : "Select designation"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      className="form-control nodesure"
                      style={{ overflowY: "scroll", maxHeight: "15vh" }}
                    >
                      {designationArray?.map((data, i) => (
                        <Dropdown.Item
                          key={i}
                          value={data}
                          onClick={() => setDesignation(data)}
                          className="d-flex justify-content-center"
                        >
                          {data}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )} */}
                  {formJson[formName].includes("designation") && (
                    <div className="form-group col-lg-6 col-md-6">
                      <label className="fw-bold">
                        Designation <font color="#FF0000">*</font>
                      </label>
                      <Select
                        className="my-2"
                        options={designationArray.map((data) => ({
                          value: data,
                          label: data,
                        }))}
                        value={
                          designation
                            ? { value: designation, label: designation }
                            : null
                        }
                        onChange={(selectedOption) =>
                          setDesignation(
                            selectedOption ? selectedOption.value : null
                          )
                        }
                        isSearchable
                        placeholder="Select designation"
                      />
                    </div>
                  )}
                  {/* {formJson[formName].includes("visiting_as") && (
                <div className="form-group col-lg-6 col-md-6">
                  <label>You are visiting show as</label>
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="transparent"
                      id="dropdown-basic"
                      className="form-control border my-2"
                    >
                      {visiting_as ? visiting_as : "Select visiting as"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      className="form-control nodesure"
                      style={{ overflowY: "scroll", maxHeight: "15vh" }}
                    >
                      {visitingAsArray?.map((data, i) => (
                        <Dropdown.Item
                          key={i}
                          value={data}
                          onClick={() => setVisiting_as(data)}
                          className="d-flex justify-content-center"
                        >
                          {data}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )} */}
                  {formJson[formName].includes("visiting_as") && (
                    <div className="form-group col-lg-6 col-md-6">
                      <label className="fw-bold">
                        You are visiting show as
                      </label>
                      <Select
                        className="my-2"
                        options={visitingAsArray.map((data) => ({
                          value: data,
                          label: data,
                        }))}
                        value={
                          visiting_as
                            ? { value: visiting_as, label: visiting_as }
                            : null
                        }
                        onChange={(selectedOption) =>
                          setVisiting_as(
                            selectedOption ? selectedOption.value : null
                          )
                        }
                        isSearchable
                        placeholder="Select visiting as"
                      />
                    </div>
                  )}
                  {formJson[formName].includes("your_company") && (
                    <div className="form-group col-lg-6 col-md-6">
                      <label>Your Company</label>
                      <input
                        className="form-control my-2"
                        placeholder="Your Company"
                        value={yourCompany}
                        onChange={(e) => {
                          setYourCompany(e.target.value);
                        }}
                      />
                    </div>
                  )}
                  {/* {formJson[formName].includes("invited_company") && (
                <div className="form-group col-lg-6 col-md-6">
                  <label>Name of the company that invited you</label>
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="transparent"
                      id="dropdown-basic"
                      className="form-control border my-2"
                    >
                      {invitedCompanyName
                        ? invitedCompanyName
                        : "Select visiting the show as"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      className="form-control nodesure"
                      style={{ overflowY: "scroll", maxHeight: "15vh" }}
                    >
                      {comapnyList?.map((data, i) => (
                        <Dropdown.Item
                          key={i}
                          value={data.company_name}
                          onClick={() => {
                            setInvitedByCompany(data._id);
                            setInvitedCompanyName(data.company_name);
                          }}
                          className="d-flex justify-content-center"
                        >
                          {data.company_name}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )} */}
                  {/* {formJson[formName].includes("invited_company") && (
                <div className="form-group col-lg-6 col-md-6">
                  <label className="fw-bold mb-2">
                    Name of the company that invited you
                  </label>
                  <Select
                    options={comapnyList.map((data) => ({
                      value: data.company_name,
                      label: data.company_name,
                    }))}
                    value={
                      invitedCompanyName
                        ? {
                            value: invitedCompanyName,
                            label: invitedCompanyName,
                          }
                        : null
                    }
                    onChange={(selectedOption) => {
                      const selectedCompany = comapnyList.find(
                        (company) =>
                          company.company_name === selectedOption.value
                      );
                      setInvitedByCompany(
                        selectedCompany ? selectedCompany._id : null
                      );
                      setInvitedCompanyName(
                        selectedOption ? selectedOption.value : null
                      );
                    }}
                    isSearchable
                    placeholder="Select the company"
                  />
                </div>
              )} */}
                  {/* {formJson[formName].includes("  ") && (
                <div className="form-group col-lg-6 col-md-6">
                  <label className="fw-bold mb-2">
                    Name of the company that invited you
                  </label>
                  <Select
                    options={comapnyList.map((data) => ({
                      value: data.company_name,
                      label: data.company_name,
                      isDisabled: data.company_name === exhibitorName, // Disable if the value matches exhibitorName
                      isSelected: data.company_name === exhibitorName, // Select if the value matches exhibitorName
                    }))}
                    value={
                      exhibitorName
                        ? {
                            value: exhibitorName,
                            label: exhibitorName,
                            isDisabled: true, // Disable the selected option
                          }
                        : null
                    }
                    onChange={(selectedOption) => {
                      const selectedCompany = comapnyList.find(
                        (company) =>
                          company.company_name === selectedOption.value
                      );
                      setInvitedByCompany(
                        selectedCompany ? selectedCompany._id : null
                      );
                      setInvitedCompanyName(
                        selectedOption ? selectedOption.value : null
                      );
                    }}
                    isSearchable
                    placeholder="Select the company"
                  />
                </div>
              )} */}
                  {formJson[formName].includes("street_add_line2") && (
                    <div className="form-group col-lg-6 col-md-6">
                      <label className="fw-bold">Address</label>
                      <input
                        className="form-control my-2"
                        placeholder="Address"
                        value={streetAddress}
                        disabled={isGSTPrefilled}
                        onChange={(e) => {
                          setStreetAddress(e.target.value);
                        }}
                      />
                    </div>
                  )}
                  {/* {formJson[formName].includes("street_add_line2") && (
                <div className="form-group col-lg-6 col-md-6 -">
                  <label className="fw-bold">Street Address Line 2</label>
                  <input
                    className="form-control my-2"
                    placeholder="Street Address Line 2"
                    onChange={(e) => {
                      setstreetAddressTwo(e.target.value);
                    }}
                  />
                </div>
              )} */}
                  {formJson[formName].includes("city") && (
                    <div className="form-group col-lg-6 col-md-6">
                      <label className="fw-bold">
                        City <font color="#FF0000">*</font>
                      </label>
                      <input
                        className="form-control my-2"
                        placeholder="City"
                        value={city}
                        disabled={isGSTPrefilled}
                        onChange={(e) => {
                          handleCity(e);
                        }}
                        maxLength={25}
                      />
                    </div>
                  )}
                  {formJson[formName].includes("state") && (
                    <div className="form-group col-lg-6 col-md-6">
                      <label className="fw-bold">State</label>
                      <input
                        className="form-control my-2"
                        placeholder="State"
                        value={state}
                        disabled={isGSTPrefilled}
                        onChange={(e) => {
                          handleState(e);
                        }}
                        maxLength={25}
                      />
                    </div>
                  )}

                  {formJson[formName].includes("zipcode") && (
                    <div className="form-group col-lg-6 col-md-6">
                      <label className="fw-bold">Postal Zip Code</label>
                      <input
                        className="form-control my-2"
                        placeholder="Postal Zip Code"
                        value={postalCode}
                        disabled={isGSTPrefilled}
                        onChange={(e) => {
                          handlePostalCode(e);
                        }}
                        maxLength={6}
                      />
                    </div>
                  )}
                  {formJson[formName].includes("country") && (
                    <div className="form-group col-lg-6 col-md-6">
                      <label className="fw-bold">
                        Country <font color="#FF0000">*</font>
                      </label>
                      <input
                        className="form-control my-2"
                        value={country}
                        placeholder="Country"
                        disabled={true}
                        onChange={(e) => {
                          handleCountry(e);
                        }}
                      />
                    </div>
                  )}
                  {/* {formJson[formName].includes("hduhear") && (
                <div className="form-group col-lg-6 col-md-6">
                  <label className="fw-bold">How do you hear about</label>
                  <input
                    className="form-control my-2"
                    placeholder="How do you hear about"
                    onChange={(e) => {
                      setHearAbout(e.target.value);
                    }}
                  />
                </div>
              )} */}
                  {/* 
              {formJson[formName].includes("visitor_category") && (
                <div className="form-group col-lg-6 col-md-6">
                  <label>Category</label>
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="transparent"
                      id="dropdown-basic"
                      className="form-control border my-2"
                    >
                      {visitingCategory ? visitingCategory : "Select category"}
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      className="form-control nodesure"
                      style={{ overflowY: "scroll", maxHeight: "15vh" }}
                    >
                      {allCategory?.map((data, i) => (
                        <Dropdown.Item
                          key={i}
                          value={data.category_name}
                          onClick={() => {
                            setVisitingCategory(data.category_name);
                            setVisitingID(data._id);
                          }}
                          className="d-flex justify-content-center"
                        >
                          {data.category_name}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )} */}
                  {formJson[formName].includes("photo") && (
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label className="fw-bold">
                          Photo{" "}
                          {formName !== "exhibitor_vip" && (
                            <font color="#FF0000">*</font>
                          )}
                          {photoStatus && (
                            <span className="photo-error">
                              Only supported (JPG/JPEG/PNG)
                            </span>
                          )}
                        </label>
                        <CommonFileUploader
                          handlePhoto={handlePhoto}
                          fileName={photo ? photo?.name : "Select File"}
                          duplicateError={null}
                          accept=".jpg, .jpeg, .png"
                          loading={isPhotoLoading}
                        />
                        {photo && (
                          <div style={styles.imageDiv}>
                            <img
                              src={URL.createObjectURL(photo)}
                              alt="Preview"
                              style={styles.previewImg}
                            />
                          </div>
                        )}
                        <p>Allowed only .png, .jpeg, .jpg</p>
                        {/* <input
                          type="file"
                          onChange={handlePhoto}
                          className="form-control"
                          accept=".jpg, .jpeg, .png"
                        /> */}
                      </div>
                    </div>
                  )}
                  {formJson[formName].includes("id_front") && (
                    <div className="col-lg-6 col-md-6 ">
                      <div className="form-group">
                        <label className="fw-bold">
                          ID Proof (Front){" "}
                          {formName !== "exhibitor_vip" && (
                            <font color="#FF0000">*</font>
                          )}
                          {idFrontStatus && (
                            <span className="photo-error">
                              Only supported (JPG/JPEG/PNG)
                            </span>
                          )}
                        </label>
                        <CommonFileUploader
                          handlePhoto={handleIDFront}
                          fileName={
                            idProofFront ? idProofFront?.name : "Select File"
                          }
                          duplicateError={null}
                          accept=".jpg, .jpeg, .png"
                        />
                        {/* <input
                          type="file"
                          onChange={handleIDFront}
                          className="form-control"
                          accept=".jpg, .jpeg, .png"
                        /> */}
                      </div>
                    </div>
                  )}
                  {formJson[formName].includes("id_back") && (
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label className="fw-bold">
                          ID Proof (Back){" "}
                          {formName !== "exhibitor_vip" && (
                            <font color="#FF0000">*</font>
                          )}
                          {idBackStatus && (
                            <span className="photo-error">
                              Only supported (JPG/JPEG/PNG)
                            </span>
                          )}
                        </label>
                        <CommonFileUploader
                          handlePhoto={handleIDBack}
                          fileName={
                            idProofBack ? idProofBack?.name : "Select File"
                          }
                          duplicateError={null}
                          accept=".jpg, .jpeg, .png"
                        />
                        {/* <input
                          type="file"
                          onChange={handleIDBack}
                          className="form-control"
                          accept=".jpg, .jpeg, .png"
                        /> */}
                      </div>
                    </div>
                  )}
                  {!ownerStatus && formJson[formName].includes("UTR") && (
                    <div className="form-group col-lg-6 col-md-6">
                      <label className="fw-bold">Transaction ID</label>
                      <input
                        className="form-control my-2"
                        placeholder="Transaction ID"
                        value={transactionId}
                        onChange={(e) => {
                          handleTransactionId(e);
                        }}
                      />
                    </div>
                  )}
                  {/* {formJson[formName].includes("visiting_day") && (
                <div className="col-lg-6 col-md-6">
                  <div className="form-group">
                    <label className="fw-bold">Visiting day</label>
                    <div className="d-flex my-2">
                      <div className="form-check me-4">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id="day_one"
                          onClick={(e) => {
                            setVisitingDay(e.target.id);
                            console.log("assadadasdad", e.target.id);
                          }}
                        />
                        <label
                          className="form-check-label"
                          for="flexRadioDefault1"
                        >
                          Day One
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id="day_two"
                          onClick={(e) => {
                            setVisitingDay(e.target.id);
                            console.log("assadadasdad", e.target.id);
                          }}
                        />
                        <label
                          className="form-check-label"
                          for="flexRadioDefault2"
                        >
                          Day Two
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}
                  <div className="form-submit">
                    <Button
                      onClick={() => {
                        handleSubmit();
                      }}
                      variant="btn btn-outline-dark"
                      disabled={isLoading || isPhotoLoading}
                    >
                      {/* {isLoading ? (
                        <Spinner animation="border" size="sm" />
                      ) : ownerStatus ? (
                        "Submit"
                      ) : (
                        "Pay Now"
                      )} */}
                      {isLoading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
      <Footer />
    </>
  );
}

export default VisitorForm;
